var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3590_38524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3590_38524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20.0094C5.16667 20.0094 4.45833 19.7177 3.875 19.1344C3.29167 18.5511 3 17.8427 3 17.0094H1V14.5094C1 14.5094 10 14.5094 11 14.5094V4.0094C11 4.0094 14.9007 3.83292 16 5.0094C16.8432 5.91172 17 8.0094 17 8.0094H20L23 12.0094V17.0094H21C21 17.8427 20.7083 18.5511 20.125 19.1344C19.5417 19.7177 18.8333 20.0094 18 20.0094C17.1667 20.0094 16.4583 19.7177 15.875 19.1344C15.2917 18.5511 15 17.8427 15 17.0094H9C9 17.8427 8.70833 18.5511 8.125 19.1344C7.54167 19.7177 6.83333 20.0094 6 20.0094ZM6 18.0094C6.28333 18.0094 6.52083 17.9136 6.7125 17.7219C6.90417 17.5302 7 17.2927 7 17.0094C7 16.7261 6.90417 16.4886 6.7125 16.2969C6.52083 16.1052 6.28333 16.0094 6 16.0094C5.71667 16.0094 5.47917 16.1052 5.2875 16.2969C5.09583 16.4886 5 16.7261 5 17.0094C5 17.2927 5.09583 17.5302 5.2875 17.7219C5.47917 17.9136 5.71667 18.0094 6 18.0094ZM18 18.0094C18.2833 18.0094 18.5208 17.9136 18.7125 17.7219C18.9042 17.5302 19 17.2927 19 17.0094C19 16.7261 18.9042 16.4886 18.7125 16.2969C18.5208 16.1052 18.2833 16.0094 18 16.0094C17.7167 16.0094 17.4792 16.1052 17.2875 16.2969C17.0958 16.4886 17 16.7261 17 17.0094C17 17.2927 17.0958 17.5302 17.2875 17.7219C17.4792 17.9136 17.7167 18.0094 18 18.0094ZM17 13.0094H21.25L19 10.0094H17V13.0094Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.6dffb21cc6ec5b84143754a669056e2e.svg";
export { ForwardRef as ReactComponent };